import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { useBillingOverview } from '@/hooks/useAdminBilling';
import { formatCurrency } from '@/utils/formatters';
import { TrendingUp, Euro } from 'lucide-react';

export function RevenueCard() {
  const { data } = useBillingOverview();
  // Billing overview API returns { mrr, arr, churn, arpu, mrrGrowth, activeSubscriptions, ... } directly
  const overview = data;

  return (
    <Card>
      <CardHeader title="Revenus" icon={<Euro className="h-4 w-4" />} />
      <CardContent>
        <div className="space-y-4">
          <div>
            <p className="text-xs font-medium uppercase tracking-wider text-neutral-500">MRR</p>
            <div className="mt-1 flex items-baseline gap-2">
              <p className="text-2xl font-bold text-neutral-900 dark:text-neutral-100">
                {overview?.mrr != null ? formatCurrency(overview.mrr) : '--'}
              </p>
              {overview?.mrrGrowth !== undefined && (
                <span className="flex items-center gap-0.5 rounded-full bg-success-50 px-1.5 py-0.5 text-xs font-medium text-success-600 dark:bg-success-500/10 dark:text-success-400">
                  <TrendingUp className="h-3 w-3" />
                  {overview.mrrGrowth}%
                </span>
              )}
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="rounded-xl bg-neutral-100 p-3 transition-colors duration-200 hover:bg-neutral-200/70 dark:bg-neutral-800/50 dark:hover:bg-neutral-800/70">
              <p className="text-xs font-medium text-neutral-500">ARR</p>
              <p className="mt-0.5 text-sm font-semibold text-neutral-800 dark:text-neutral-200">
                {overview?.arr != null ? formatCurrency(overview.arr) : '--'}
              </p>
            </div>
            <div className="rounded-xl bg-neutral-100 p-3 transition-colors duration-200 hover:bg-neutral-200/70 dark:bg-neutral-800/50 dark:hover:bg-neutral-800/70">
              <p className="text-xs font-medium text-neutral-500">ARPU</p>
              <p className="mt-0.5 text-sm font-semibold text-neutral-800 dark:text-neutral-200">
                {overview?.arpu != null ? formatCurrency(overview.arpu) : '--'}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2 rounded-xl bg-primary-500/10 p-3 border border-primary-500/20">
            <Euro className="h-4 w-4 text-primary-400" />
            <span className="text-xs font-medium text-primary-600 dark:text-primary-300">
              {overview?.activeSubscriptions ?? '--'} abonnements actifs
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
